import { ILanguage } from '../language/language';

export interface IContact {
  /** Contact ID */
  contactID: number;
  /** Picture of the contact */
  picture?: string;
  /** Appellation */
  apellation: Appellation;
  /** First name */
  firstName?: string;
  /** Last name */
  lastName?: string;
  /** Phone number */
  phone?: string;
  /** Mobile phone number */
  mobile?: string;
  /** Fax number */
  fax?: string;
  /** Position in the company */
  position?: string;
  /** Homepage of the contact */
  homepage?: string;
  /** E-Mail address */
  eMail?: string;
  /** Company name */
  company?: string;
  /** Language of this contact */
  language?: ILanguage;
  /** Date of birth */
  birthdayOn?: Date;
  /** Predefined string from backend to display the contact */
  displayName: string;
}

export enum Appellation {
  Company = 0,
  Mr = 1,
  Mrs = 2,
  None = 3,
  Diverse = 4,
  Miss = 5,
  Ms = 6,
  Dr = 7,
  Family = 8
}
